import { render, staticRenderFns } from "./ScientificPracticalEvent.vue?vue&type=template&id=2a1a6b16&scoped=true"
import script from "./ScientificPracticalEvent.vue?vue&type=script&lang=js"
export * from "./ScientificPracticalEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1a6b16",
  null
  
)

export default component.exports